import {FilterOptionValue} from 'Core/models/FilterOption';
import React from 'react';
import {FilterChip} from 'Shared/components/FilterChip';

export const getChipLabel = FilterOptionValue.match({
  EmptyOption: () => '',
  SelectedOption: option => option.name,
});

export const withChip = <TFilter extends {}, TKey extends keyof TFilter>(
  fieldName: string,
  fieldPropertyName: TKey,
  clearFilter: (fieldPropertyName: TKey) => (defaultValue: any) => void,
  getFieldValue?: (value: TFilter[TKey]) => string,
  defaultValue?: any
) => (filter: TFilter) => (
  <FilterChip
    // @ts-ignore
    key={`filter__${fieldName}-${fieldPropertyName}`}
    fieldName={fieldName}
    onDelete={() => clearFilter(fieldPropertyName)(defaultValue || '')}
    fieldValue={
      getFieldValue ? getFieldValue(filter[fieldPropertyName]) : ((filter[fieldPropertyName] as unknown) as string)
    }
  />
);
